export const attachmentsConstants = {
    getAllAttachmentsLoaderState: 'GET_ALL_ATTACHMENTS_LOADER_STATE',
    getAllAttachments: 'GET_ALL_ATTACHMENTS',
    updateAttachment:'UPDATE_ATTACHMENT',
    uploadAttachmentToAws: 'UPLOAD_ATTACHMENT_TO_AWS',
    addNewAttachment: 'ADD_NEW_ATTACHMENT',
    addNewAttachmentLoaderState: 'ADD_NEW_ATTACHMENT_LOADER_STATE'
}